import React, { Component, Fragment } from 'react';

import HomeStatTable from './HomeStatTable';
import HomeStatModal from './HomeStatModal';

class HomeStat extends Component {
  state = {
    showEditor: false,
    selected: null,
  }

  handleShowEditor = (selected) => {
    let info;
    if (selected) {
      info = { ...selected };
    } else {
      info = null;
    }
    this.setState({
      showEditor: true,
      selected: info,
    });
  }

  render() {
    const { showEditor, selected } = this.state;
    return (
      <Fragment>
        <HomeStatTable showEditor={this.handleShowEditor} />
        <HomeStatModal
          visible={showEditor}
          onCancel={() => this.setState({
            showEditor: false,
            selected: null,
          })}
          initialValue={selected}
        />
      </Fragment>
    );
  }
}

export default HomeStat;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/HomeStat/HomeStat.js